import React from 'react';
import { Card } from 'react-bootstrap';
import * as LuIcon from 'react-icons/lu';

import { GetStageHintDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../translations';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { TimelineHintDeadlineObj } from '../../../common/pokCore/validation/enums';

interface StageModalHintsProps {
  hints: GetStageHintDto[];
}

export const StageModalHints: React.FC<StageModalHintsProps> = ({ hints }) => {
  const { t, tk } = useTranslation('projectLng');
  const pok = usePokCore();
  const lang = pok.getLanguage();

  if (hints.length === 0) {
    return null;
  }

  return (
    <Card className="stage-modal-card stage-modal-card-hints rounded-3">
      <h6 className="fw-semibold mb-2 d-flex align-items-center gap-2 text-dark">
        <LuIcon.LuLightbulb className="stage-modal-section-icon" />
        {t(tk.timeLine.hints)}
      </h6>
      <ul className="mb-0 ps-3 ">
        {hints.map((hint, index) => (
          <li key={index} className="text-warning mb-2 ms-3">
            <span className="text-secondary pe-1">
              {lang === 'PL' ? hint.descriptionPl : hint.descriptionEn}
            </span>
            {hint.deadline && (
              <span className="bg-info bg-opacity-25 text-secondary d-inline-flex align-items-center gap-1 small stage-modal-hint-deadline px-2 py-1">
                {t(tk.timeLine.deadlineWithTime, {
                  deadline: t(TimelineHintDeadlineObj[hint.deadline]),
                })}
              </span>
            )}
          </li>
        ))}
      </ul>
    </Card>
  );
};
